import React from 'react';
import { motion } from 'framer-motion';
import { LayoutDashboard, Wrench, Activity, Truck } from 'lucide-react';
export function PortalSlide() {
  return <div className="h-full w-full flex flex-col items-center justify-center px-8 bg-slate-950 relative overflow-hidden" data-id="element-81">
      {/* Background grid effect */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20 pointer-events-none" data-id="element-82" />

      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center mb-12 relative z-10" data-id="element-83">
        <div className="inline-flex items-center justify-center p-3 bg-purple-500/10 rounded-xl mb-6" data-id="element-84">
          <LayoutDashboard className="w-10 h-10 text-purple-500" data-id="element-85" />
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-86">
          Management Portal
        </h2>
        <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-87">
          Complete visibility and control over your entire charging
          infrastructure.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl w-full relative z-10" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-slate-900/80 backdrop-blur-sm border border-slate-800 p-8 rounded-2xl" data-id="element-89">
          <Wrench className="w-8 h-8 text-blue-400 mb-4" data-id="element-90" />
          <h3 className="text-xl font-bold text-white mb-2" data-id="element-91">
            Remote Management
          </h3>
          <p className="text-slate-400" data-id="element-92">
            Manage installations remotely without needing physical access.
            Configure settings and troubleshoot instantly.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="bg-slate-900/80 backdrop-blur-sm border border-slate-800 p-8 rounded-2xl" data-id="element-93">
          <Activity className="w-8 h-8 text-green-400 mb-4" data-id="element-94" />
          <h3 className="text-xl font-bold text-white mb-2" data-id="element-95">Deep Insights</h3>
          <p className="text-slate-400" data-id="element-96">
            Access detailed home data and smart charging behavior analytics
            often missed by standard OEM solutions.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-slate-900/80 backdrop-blur-sm border border-slate-800 p-8 rounded-2xl" data-id="element-97">
          <Truck className="w-8 h-8 text-purple-400 mb-4" data-id="element-98" />
          <h3 className="text-xl font-bold text-white mb-2" data-id="element-99">
            Zero Truck Rolls
          </h3>
          <p className="text-slate-400" data-id="element-100">
            Drastically reduce on-site maintenance visits. Diagnose and fix
            issues from your desk.
          </p>
        </motion.div>
      </div>

      {/* Dashboard Preview Abstract */}
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6,
      duration: 0.8
    }} className="mt-12 w-full max-w-4xl h-64 bg-slate-900 rounded-t-2xl border-t border-x border-slate-800 relative overflow-hidden opacity-50 mask-image-gradient-to-b" data-id="element-101">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-950 z-20" data-id="element-102" />
        <div className="p-6 grid grid-cols-4 gap-4" data-id="element-103">
          <div className="h-32 bg-slate-800/50 rounded-lg col-span-1" data-id="element-104" />
          <div className="h-32 bg-slate-800/50 rounded-lg col-span-1" data-id="element-105" />
          <div className="h-32 bg-slate-800/50 rounded-lg col-span-2" data-id="element-106" />
          <div className="h-32 bg-slate-800/50 rounded-lg col-span-4" data-id="element-107" />
        </div>
      </motion.div>
    </div>;
}